import { Modal, Space } from "antd";
import React from "react";
import QRCode from "react-qr-code";

export const QRModal = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  const linkRegister = import.meta.env.VITE_MEETING_DOMAIN || "";
  return (
    <Modal
      title="Mã đăng ký tham gia"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <QRCode value={linkRegister} />
        <a href={linkRegister}>{linkRegister}</a>
      </Space>{" "}
    </Modal>
  );
};
